<!-- 工作台--候选列表 -->
<template>
  <div class="candidateList">
    <div class="filtrateTab">
      <div class="spot">
        <div class="label">期望地点：</div>
        <CascaderArea country="" province="" city="" @searchArae="searchArae"></CascaderArea>
      </div>

      <div class="experience">
        <div class="label">工作经验：</div>
        <div
          class="experience_item"
          :class="{
            active: index == experienceIndex
          }"
          v-for="(item, index) in experienceList"
          :key="index"
          @click="clickExperience(item, index)"
        >
          {{ item.value }}
        </div>
      </div>

      <div class="positionType">
        <div class="label">职位类型：</div>
        <div
          :class="{
            active: index == positionTypeIndex
          }"
          class="positionType_item"
          v-for="(item, index) in positionTypeList"
          :key="item.codeId"
          @click="clickPositionTypeItem(item, index)"
        >
          {{ item.codeName }}
        </div>
      </div>
    </div>
    <div class="candidateList_main">
      <!-- 头部搜索 -->
      <div class="headSearch el-dropdown-link">
        <div class="search_keyword">
          <el-input
            @change="searchKeywordChange"
            v-model="searchKeyword"
            placeholder="请输入关键词"
          ></el-input>
          <div class="search_icon_box" @click="searchKeywordChange">
            <i style="color: #fff" class="el-icon-search"></i>
          </div>
        </div>
        <div class="matching_candidate" @click="clickMatchingCandidate">匹配候选人</div>
        <!-- <el-dropdown @command="handleCommand">
          <div class="add_candidate">＋添加候选人</div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="简历新增" class="uploadTalent_box">
              <up-load @personCode="uploadPersonCode" name="简历新增"></up-load>
            </el-dropdown-item>
            <el-dropdown-item command="本地新增">本地新增</el-dropdown-item>
            <el-dropdown-item command="从人才库新增">从人才库新增</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown> -->
        <div
          class="add_candidate position_re"
          @mouseenter="showBtnListHandle"
          @mouseleave="hideBtnlistHandle"
        >
          ＋添加候选人
          <ul
            class="position_ab"
            v-show="showBtnList"
            @mouseenter="showBtnListHandle"
            @mouseleave="hideBtnlistHandle"
          >
            <li>
              <up-load @personCode="uploadPersonCode" name="简历新增"></up-load>
            </li>
            <li class="pad_li" @click="addPersonBtnClick(1)">本地新增</li>
            <li class="pad_li" @click="addPersonBtnClick(2)">从人才库新增</li>
          </ul>
        </div>
        <div class="remove_candidate" @click="remove">+ 移除候选人</div>
      </div>
    </div>

    <div class="candidate_list">
      <div
        class="candidate_list_item"
        :class="{
          active: item.isSelected
        }"
        v-for="(item, index) in queryList"
        :key="index"
        @click="clickAddActive(item, index)"
      >
        <!-- 人物信息 -->
        <div class="left">
          <div class="image_box">
            <img class="img" :src="item.headPortraits" alt="" />
          </div>
          <div class="list_info">
            <div class="user_info">
              <div class="user_name">{{ item.name }}</div>
              <!-- <div class="matching_rate">
                匹配度
                <el-progress
                  :width="16"
                  :show-text="false"
                  :stroke-width="2"
                  type="circle"
                  :percentage="75"
                  style="margin: 0 2px 0 5px"
                  color="#17757a"
                ></el-progress>
                <span style="font-size: 14px">75%</span>
              </div> -->
            </div>
            <div class="shool" v-if="item.personEducational && item.personEducational.length != 0">
              <i class="el-icon-office-building" style="color: #17757a"></i>
              <span style="margin-left: 6px"
                >{{ item.personEducational[0].schoolName }}-{{ item.personEducational[0].major }}-{{
                  item.personEducational[0].education
                }}</span
              >
            </div>
            <div class="else">
              {{ item.expectedPosition }} <span class="else_line"></span> {{ item.workingYears }}
              <div class="else_line"></div>
              {{ item.expectedProvince }}- {{ item.expectedCity }}
            </div>
          </div>
        </div>

        <!-- 进度 -->
        <div class="center">
          <div class="timeline" v-if="item.personExperience">
            <el-timeline :reverse="true">
              <el-timeline-item
                v-for="(items, index) in item.personExperience"
                :key="index + 10"
                v-show="index < 3"
              >
                <span style="color: #808080; margin-right: 5px" class="endTimeStyle"
                  >{{ items.inductionTime }}-
                  <span v-if="items.quitTime !== '1999'">{{ items.quitTime }}</span>
                  <span v-else style="color: #999999">至今</span></span
                >
                <span style="color: #1a1f33; margin-right: 5px" v-if="items.companyName">{{
                  items.companyName
                }}</span>
                <span style="color: #1a1f33; margin-right: 5px" v-if="items.position">{{
                  items.position
                }}</span>
              </el-timeline-item>
            </el-timeline>
          </div>
        </div>

        <!-- 操作 -->
        <div class="right">
          <div class="right_options">
            <div class="add_list" @click="clickAddList(item)">+沟通列表</div>
            <div class="examine" @click="edit(item)">查看详情</div>
          </div>
          <div class="right_source">信息来源：{{ item.source }}</div>
          <div class="updateTime">最近更新时间：{{ item.updateName }}</div>
        </div>
      </div>
    </div>

    <div class="pagination_box">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="1"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>

    <!-- 添加候选人对话框 -->
    <div class="addCandidateDialog">
      <el-dialog :visible.sync="addCandidateDialog" width="880px" @close="handleClose">
        <span slot="title" class="dialog-footer">
          <div class="head_title">
            <div class="line"></div>
            <div class="txt">添加候选人</div>
            <div class="search_candidate">
              <el-input
                v-model="query.name"
                placeholder="请输入关键词"
                clearable
                @change="clear_input"
              >
              </el-input>
              <div @click="search_candidate" class="search_candidate_box">
                <i style="color: #fff" class="el-icon-search"></i>
              </div>
            </div>
          </div>
        </span>
        <div class="addCandidateDialog_main">
          <div class="addCandidateDialog_main_title">
            <div>共匹配到{{ total }}位候选人</div>
            <div class="addCandidateDialog_main_title_right">
              已选<span class="select">{{ selectSum }}</span>
            </div>
          </div>

          <div class="addCandidateDialog_main_box">
            <!-- 每一项 -->
            <div
              class="addCandidateDialog_main_item"
              v-for="(item, index) in addCandidateDialogList"
              :key="index"
            >
              <div class="left">
                <!-- 勾选按钮 -->
                <div class="check">
                  <el-checkbox
                    @change="CandidateCheckbox(item, index)"
                    v-model="item.isPitchOn"
                  ></el-checkbox>
                </div>
                <!-- 头像 -->
                <div class="img_box">
                  <img :src="item.headPortraits" alt="" class="img" />
                </div>
                <!-- 信息 -->
                <div class="info">
                  <div class="userName">{{ item.name }}</div>
                  <div
                    class="shool"
                    v-if="item.personEducational && item.personEducational.length != 0"
                  >
                    <i class="el-icon-office-building" style="color: #17757a"></i>
                    <span style="margin-left: 6px"
                      >{{ item.personEducational[0].schoolName }}
                      {{ item.personEducational[0].major }}
                      {{ item.personEducational[0].education }}</span
                    >
                  </div>
                  <div class="else">
                    {{ item.personType }} <span class="else_line"></span> {{ item.workingYears }}
                    <div class="else_line"></div>
                    {{ item.personProvince }}-{{ item.personCity }}
                  </div>
                </div>
              </div>

              <div class="right">
                <!-- 匹配度 -->
                <!-- <div class="matching_rate">
                  匹配度
                  <el-progress
                    :width="16"
                    :show-text="false"
                    :stroke-width="2"
                    type="circle"
                    :percentage="75"
                    style="margin: 0 2px 0 5px"
                    color="#17757a"
                  ></el-progress>
                  75%
                </div> -->

                <!-- 查看详情 -->
                <div class="details">查看详情</div>
              </div>
            </div>
          </div>
          <!-- 分页 -->
          <div class="pagination_box">
            <el-pagination
              @size-change="handleSizeChangeDialog"
              @current-change="handleCurrentChangeDialog"
              :current-page="1"
              :page-sizes="[10, 20, 30, 50]"
              :page-size="10"
              layout="total, sizes, prev, pager, next, jumper"
              :total="totalTwo"
            >
            </el-pagination>
          </div>
          <!-- 操作按钮 -->
          <div class="btn_list">
            <div class="add" @click="clickAddSaveIntermediate">添加</div>
            <div class="cancel" @click="addCandidateDialog = false">取消</div>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import CascaderArea from '../../../../../components/CascaderArea'
// codeType 008 查询职位类型
import { codeType } from '../../../../../api/common.js'
import UpLoad from '@/components/UploadFileDIY.vue'
import {
  selectIntermediate,
  getHomePage,
  saveIntermediateListTwo,
  selectExist,
  updateIntermediate,
  CandidateRecordsSave,
  deleteIntermediate
} from '../../../../../api/projectCenter.js'
const defaultQueryInfo = Object.freeze({
  // 页码数和页面大小
  baseParam: {
    pageNum: 1, // 页数
    pageSize: 10 // 大小
  },
  expectedCity: '', // 期望城市
  expectedCountry: '', // 期望国家
  expectedProvince: '', // 期望省份
  id: 0, // 项目id
  personType: '', // 职位类型
  projectSchedule: null, // 候选人传null，沟通列表正常传值
  workingYears: '', //  工作经验/工作年限(1->1;2->1~3;3->3~5;4->5~10;5->10),
  total: 0,
  createTime: null, // 添加时间desc,asc
  progressTalent: null, // 人才进度desc,asc
  updateTime: 'desc' // 最近更新时间desc,asc
})
export default {
  components: {
    CascaderArea,
    UpLoad
  },
  data() {
    return {
      showBtnListTimer: null, // 定时器标识
      showBtnList: false, // 展示新增人才按钮列表
      query: {
        beginAge: '',
        companyName: '',
        currentIndustry: '',
        finishAge: '',
        name: '',
        pageNum: 1,
        pageSize: 10,
        personCity: '',
        personCountry: '中国',
        personProvince: '',
        personSchedule: '',
        personType: [],
        position: '',
        state: '',
        workingYears: ''
      },
      queryInfo: { ...defaultQueryInfo },
      // 工作经验
      experienceList: [
        {
          value: '不限',
          id: 0
        },
        {
          value: '1年',
          id: 1
        },
        {
          value: '1~3年',
          id: 2
        },
        {
          value: '3~5年',
          id: 3
        },
        {
          value: '5~10年',
          id: 4
        },
        {
          value: '10年以上',
          id: 5
        }
      ],
      // 职位类型
      positionTypeList: [],
      positionTypeIndex: 0,
      experienceIndex: 0,
      queryList: [],
      total: 0,
      searchKeyword: '',
      addCandidateDialog: false,
      checked: false,
      addCandidateDialogList: [],
      selectSum: 0,
      //
      candidateIdList: [],
      idList: [],
      totalTwo: 0
    }
  },

  computed: {
    item() {
      return JSON.parse(this.$route.query.item)
    }
  },

  watch: {},
  created() {
    this.getPositionType()
    this.search()
  },
  methods: {
    // 本地上传返回code  手动新增
    async uploadPersonCode(val) {
      console.log(val)
      let personCode = []
      personCode.push(val)
      const { data: res } = await saveIntermediateListTwo({
        personCode: personCode,
        projectId: JSON.parse(this.$route.query.item).id
      })
      if (res.resultCode == 200) {
        this.$message.success('添加成功')
        this.search()
      }
    },
    // 地点查询
    searchArae(val) {
      this.queryInfo.expectedCountry = val.country
      this.queryInfo.expectedCity = val.province
      this.queryInfo.expectedProvince = val.city
      this.search()
    },
    // 显示新增人才按钮列表
    showBtnListHandle() {
      if (this.showBtnListTimer) {
        clearTimeout(this.showBtnListTimer)
        this.showBtnListTimer = null
      }
      if (!this.showBtnList) {
        this.showBtnList = true
      }
    },

    // 隐藏新增人才按钮列表
    hideBtnlistHandle() {
      if (this.showBtnList) {
        this.addTimeoutHandle()
      }
    },
    // 定时器--隐藏新增人才按钮列表
    addTimeoutHandle() {
      this.showBtnListTimer = setTimeout(() => {
        this.showBtnList = false
      }, 500)
    },
    //
    async addPersonBtnClick(id) {
      if (id === 1) {
        // 本地新增
        this.$router.push({
          name: 'TalentMessage',
          query: {
            searchInfo: JSON.stringify(this.queryInfo),
            uploadState: 'true',
            projectAddId: this.item.id
          }
        })
      } else {
        // 人才库新增
        this.query.personCountry = '中国'
        const { data: res } = await getHomePage(this.query)
        if (res.code === 200) {
          this.addCandidateDialogList = res.data.content
          this.totalTwo = res.titleCount
        }
        this.addCandidateDialog = true
      }
    },
    // edit(item) {
    //   this.$router.push({
    //     name: 'TalentMessage',
    //     query: {
    //       id: item.personCode,
    //       clientType: 1
    //     }
    //   })
    // },
    // 查看人才详情
    edit(item) {
      this.$router.push({
        path: '/dataManagement/TalentMessage',
        query: {
          id: item.personCode,
          clientType: 1
        }
      })
    },
    async search() {
      // console.log('2')
      this.queryInfo.id = JSON.parse(this.$route.query.item).id
      const { data: res } = await selectIntermediate(this.queryInfo)
      if (res.resultCode == 200) {
        // console.log(res)
        this.queryList = res.data.list
        this.total = res.data.total
        this.$emit('setTabTotal', 1, this.total)
      }
    },
    async getPositionType() {
      const { data: res } = await codeType({
        code: '008'
      })
      if (res.resultCode == 200) {
        this.positionTypeList = res.data
        this.positionTypeList.unshift({
          codeName: '不限',
          codeId: 0,
          codeType: '008'
        })
      }
    },
    clickExperience(item, index) {
      this.experienceIndex = index
      if (item.id == 0) {
        this.queryInfo.workingYears = ''
        this.search()
      } else {
        this.queryInfo.workingYears = item.id
        this.search()
      }
    },
    clickPositionTypeItem(item, index) {
      console.log(item)
      this.positionTypeIndex = index
      if (item.id == 0) {
        this.queryInfo.personType = ''
        this.search()
      } else {
        this.queryInfo.personType = item.codeName
        this.search()
      }
    },
    // 分页
    handleSizeChange(val) {
      this.queryInfo.baseParam.pageSize = val
      this.search()
    },
    handleCurrentChange(val) {
      this.queryInfo.baseParam.pageNum = val
      this.search()
    },
    // 搜索
    searchKeywordChange() {
      // console.log(this.searchKeyword)
      return this.$message('敬请期待!')
    },
    async handleCommand(command) {
      if (command == '本地新增') {
        this.$router.push({
          name: 'TalentMessage',
          query: {
            searchInfo: JSON.stringify(this.queryInfo),
            uploadState: 'true',
            projectAddId: this.item.id
          }
        })
      } else if (command == '从人才库新增') {
        // 人才es查询
        const { data: res } = await getHomePage(this.query)
        if (res.code == 200) {
          console.log(res)
          this.addCandidateDialogList = res.data.content
          this.totalTwo = res.titleCount
        }
        this.addCandidateDialog = true
      }
      // else if (command == '本地新增') {
      // }
    },
    // 分页
    handleSizeChangeDialog(val) {
      this.query.pageSize = val
      this.handleCommand('从人才库新增')
    },
    handleCurrentChangeDialog(val) {
      this.query.pageNum = val
      this.handleCommand('从人才库新增')
    },
    // 关闭
    handleClose() {
      this.candidateIdList = []
      this.query = {
        beginAge: '',
        companyName: '',
        currentIndustry: '',
        finishAge: '',
        name: '',
        pageNum: 1,
        pageSize: 10,
        personCity: '',
        personCountry: '',
        personProvince: '',
        personSchedule: '',
        personType: [],
        position: '',
        state: '',
        workingYears: ''
      }
    },
    //
    async CandidateCheckbox(item, index) {
      if (item.isPitchOn == true) {
        let query = {
          personCode: item.personCode,
          projectId: JSON.parse(this.$route.query.item).id * 1
        }
        const { data: res } = await selectExist(query)
        if (res.data == true) {
          this.$message('这条数据已在列表中,请勿重复添加')
          return (this.addCandidateDialogList[index].isPitchOn = false)
        }
      }

      this.selectSum = 0
      this.candidateIdList = []
      this.addCandidateDialogList.forEach((item, index) => {
        if (item.isPitchOn == true) {
          this.selectSum++
          this.candidateIdList.push(item.personCode)
        }
      })
    },
    //
    async clickAddSaveIntermediate() {
      console.log(this.candidateIdList)
      if (this.candidateIdList.length == 0) {
        return this.$message('请勾选数据后重试')
      }
      const { data: res } = await saveIntermediateListTwo({
        personCode: this.candidateIdList,
        projectId: JSON.parse(this.$route.query.item).id
      })
      if (res.resultCode == 200) {
        this.$message.success('添加成功')
        this.search()
      }

      this.addCandidateDialog = false
    },
    // 添加沟通列表
    async clickAddList(item) {
      let query = [
        {
          id: item.id,
          personCode: item.personCode,
          projectId: item.projectId,
          talentProgress: '人才报告'
        }
      ]

      // let queryInfo = {
      //   achievementBonus: 0,
      //   annualBonus: 0,
      //   annualSalary: 0,
      //   commission: 0,
      //   createName: '',
      //   createTime: '',
      //   employment: '',
      //   id: null,
      //   monthlySalary: 0,
      //   operationConsultant: '',
      //   other: '',
      //   personnelId: '',
      //   projectId: item.projectId,
      //   talentDetails: '',
      //   talentProgress: '人才报告',
      //   updateName: sessionStorage.getItem('userName'),
      //   updateTime: '',
      //   uploadAttachments: ''
      // }
      const { data: res } = await updateIntermediate(query)
      if (res.resultCode == 200) {
        this.$message.success('添加成功')
        this.search()
        this.$emit('handleList')
        // const { data: res } = await CandidateRecordsSave(queryInfo)
        // console.log(res)
      }
    },
    clickMatchingCandidate() {
      this.$message('功能正在开发中，敬请期待')
    },
    clickAddActive(item, index) {
      this.queryList[index].isSelected = !this.queryList[index].isSelected
      let idList = []
      this.queryList.forEach((item, index) => {
        if (item.isSelected) {
          idList.push(item.id)
        }
      })
      this.idList = idList
    },
    async remove() {
      let ids = this.idList
      const { data: res } = await deleteIntermediate(ids)
      if (res.resultCode == 200) {
        console.log(res)
        this.$message.success('删除成功')
        this.search()
      }
    },
    async search_candidate() {
      const { data: res } = await getHomePage(this.query)
      this.addCandidateDialogList = res.data.content
      // console.log("人才数据",res.data.content);
    },
    async clear_input(val) {
      if (!val) {
        const { data: res } = await getHomePage(this.query)
        this.addCandidateDialogList = res.data.content
      }
    }
  },

  mounted() {}
}
</script>
<style scoped lang="less">
.uploadTalent_box {
  // display: none;
  // border: 1px solid red;
  /deep/ .el-button {
    font-size: 14px;
    text-align: left;
    width: auto;
    padding: 0;
    border: none;
    color: #606266;
  }
  &:hover /deep/ .el-button {
    color: #151515;
  }
}
.candidateList {
  padding-bottom: 36px;

  .filtrateTab {
    padding: 12px 0 12px 0;
    background-color: #fff;

    .spot {
      display: flex;
      align-items: center;
      margin-bottom: 18px;
      padding-left: 24px;

      .label {
        color: #333333;
        font-size: 14px;
      }
    }
    .experience {
      display: flex;
      align-items: center;
      margin-bottom: 18px;
      padding-left: 24px;
      .label {
        color: #333333;
        font-size: 14px;
      }

      .experience_item {
        padding: 3px 10px;
        font-size: 14px;
        color: #333333;
        cursor: pointer;
        margin-right: 15px;
        box-sizing: border-box;
      }
      .active {
        border: 1px solid #17757a;
        border-radius: 4px;
        color: #17757a;
        font-size: 15px;
      }
    }
    .positionType {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      margin-bottom: 18px;
      padding-left: 24px;
      .label {
        margin-bottom: 10px;
        color: #333333;
        font-size: 14px;
      }

      .positionType_item {
        padding: 3px 10px;
        font-size: 14px;
        color: #333333;
        cursor: pointer;
        margin-bottom: 10px;
        margin-right: 15px;
        box-sizing: border-box;
      }
      .active {
        border: 1px solid #17757a;
        color: #17757a;
        border-radius: 4px;
        font-size: 15px;
      }
    }
  }
  .candidateList_main {
    background-color: #fff;
    .headSearch {
      height: 66px;
      display: flex;
      flex-flow: row nowrap;
      align-items: center;
      justify-content: flex-end;
      border-bottom: 1px solid #dcdee0;
      margin-top: 20px;
      padding-right: 67px;

      .remove_candidate {
        border-radius: 4px;
        border: 1px solid #17757a;
        padding: 8px 5px;
        color: #17757a;
        font-size: 14px;
        cursor: pointer;
        margin-left: 17px;
      }
      .add_candidate {
        border-radius: 4px;
        border: 1px solid #17757a;
        padding: 8px 5px;
        color: #17757a;
        font-size: 14px;
        cursor: pointer;
        margin-left: 17px;
      }
      .position_re {
        position: relative;

        .position_ab {
          position: absolute;
          top: 40px;
          left: 0;
          z-index: 99;
          width: fit-content;
          display: flex;
          flex-flow: column;
          background-color: #fff;
          border: 1px solid #ebeef5;
          box-shadow: 0px 0px 4px 0px #00000026;
          border-radius: 4px;
          .pad_li {
            padding: 8px 14px;
          }
          li {
            width: 100%;
            white-space: nowrap;
            cursor: pointer;
            font-size: 14px;
            line-height: 24px;
            color: #000;
            // font-weight: 550;
            box-sizing: border-box;
            ::v-deep .el-upload {
              width: 100%;
            }
            ::v-deep .el-button {
              font-size: 14px;
              text-align: left;
              width: 100%;
              padding: 16px 14px 8px 14px;
              border: none;
              color: #000;
            }
          }
          li:hover {
            color: #606266;
            background-color: #f5f7fa;
          }
        }
      }
      .matching_candidate {
        width: 101px;
        display: flex;
        align-items: center;
        justify-content: center;
        box-sizing: border-box;
        border-radius: 4px;
        padding: 8px 5px;
        color: #fff;
        background-color: #17757a;
        font-size: 14px;
        cursor: pointer;
        margin-left: 17px;
      }
    }
    .search_keyword {
      display: flex;
      /deep/.el-input {
        width: 289px;
        height: 36px;
      }
      /deep/.el-input__inner {
        width: 289px;
        height: 36px;
      }
      .search_icon_box {
        width: 48px;
        height: 36px;
        background-color: #17757a;
        display: flex;
        align-items: center;
        justify-content: center;
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
        cursor: pointer;
      }
    }
  }

  .candidate_list {
    .active {
      border: 1px solid #17757a;
    }
    .candidate_list_item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 104px;
      background-color: #fff;
      padding-left: 11px;
      margin-bottom: 15px;

      .left {
        display: flex;
        height: 74px;
        .image_box {
          margin-right: 11px;
          width: 72px;
          height: 74px;
          .img {
            width: 100%;
            height: 100%;
            border-radius: 4px;
          }
        }
        .list_info {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          .user_info {
            display: flex;
            align-items: center;
            .user_name {
              color: #333333;
              font-size: 18px;
              font-weight: 600;
              margin-right: 20px;
            }
            .matching_rate {
              display: flex;
              align-items: center;
            }
          }
          .shool {
            color: #17757a;
            font-size: 12px;
            font-weight: 400;
            border: 1px solid rgba(23, 117, 122, 0.2);
            padding: 3px 6px;
          }
          .else {
            font-size: 14px;
            color: #666666;
            display: flex;
            align-items: center;

            .else_line {
              width: 1px;
              height: 11px;
              background-color: #b2b2b2;
              margin: 0 8px 0 6px;
            }
          }
        }
      }

      .center {
        .timeline {
          // margin-left: 100px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          /deep/ .el-timeline {
            display: flex;
            flex-direction: column;
            .el-timeline-item {
              padding: 20px 0 0 0;
            }
          }
        }
        /deep/.el-timeline-item {
          padding: 0 !important;
        }
        /deep/ .el-timeline-item__node {
          border: 3px solid #17757a;
          box-sizing: border-box;
          background-color: #fff;
        }
        /deep/ .el-timeline-item__tail {
          border-left: 2px solid #17757a;
        }
      }

      .right {
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
        padding-right: 70px;

        .right_options {
          display: flex;
          align-items: center;

          .add_list {
            width: 89px;
            height: 32px;
            border-radius: 4px;
            font-size: 14px;
            border: 1px solid #17757a;
            margin-right: 34px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #17757a;
            cursor: pointer;
          }
          .examine {
            font-size: 14px;
            color: #17757a;
            cursor: pointer;
          }
        }

        .right_source {
          color: #999999;
          font-size: 12px;
        }

        .updateTime {
          color: #999999;
          font-size: 12px;
        }
      }
    }
  }

  .pagination_box {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 100px;
  }

  .addCandidateDialog {
    .head_title {
      display: flex;
      margin-right: 40px;
      .line {
        width: 4px;
        height: 20px;
        border-radius: 4px;
        background-color: #17757a;
        margin-right: 8px;
      }

      .txt {
        color: #333333;
        font-size: 16px;
        font-weight: 600;
      }

      .search_candidate {
        display: flex;
        // 方法一
        margin-left: auto;
        /deep/.el-input {
          width: 289px;
          height: 36px;
        }
        /deep/.el-input__inner {
          width: 289px;
          height: 36px;
        }
        .search_candidate_box {
          width: 48px;
          height: 36px;
          background-color: #17757a;
          display: flex;
          align-items: center;
          justify-content: center;
          border-top-right-radius: 4px;
          border-bottom-right-radius: 4px;
          cursor: pointer;
        }
      }
    }
    .addCandidateDialog_main {
      margin-top: 26px;
      height: 600px;

      .addCandidateDialog_main_title {
        color: #333333;
        font-size: 14px;
        line-height: 20px;
        display: flex;
        justify-content: space-between;
        padding-left: 20px;
        padding-right: 200px;
        margin-bottom: 14px;

        .addCandidateDialog_main_title_right {
          .select {
            color: #17757a;
            margin-left: 8px;
          }
        }
      }

      .addCandidateDialog_main_box {
        width: 800px;
        height: calc(100% - 140px);
        overflow-y: auto;
        border-top: 1px solid #dcdee0;
        box-sizing: border-box;

        .addCandidateDialog_main_item {
          height: 104px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding-right: 20px;
          box-sizing: border-box;
          border-bottom: 1px solid#DCDEE0;

          .left {
            display: flex;
            align-items: center;
            .check {
              width: 72px;
              display: flex;
              align-items: center;
              justify-content: center;
            }
            .img_box {
              width: 72px;
              height: 74px;
              margin-right: 11px;
              .img {
                width: 100%;
                height: 100%;
                border: 4px;
              }
            }
            .info {
              height: 74px;
              display: flex;
              flex-direction: column;
              justify-content: space-between;
              .userName {
                font-size: 18px;
                font-weight: 600;
                color: #333333;
              }
              .shool {
                color: #17757a;
                font-size: 12px;
                font-weight: 400;
                border: 1px solid rgba(23, 117, 122, 0.2);
                padding: 3px 6px;
              }
              .else {
                font-size: 14px;
                color: #666666;
                display: flex;
                align-items: center;

                .else_line {
                  width: 1px;
                  height: 11px;
                  background-color: #b2b2b2;
                  margin: 0 8px 0 6px;
                }
              }
            }
          }

          .right {
            display: flex;
            align-items: center;
            .matching_rate {
              display: flex;
              align-items: center;
            }
            .details {
              margin-left: 44px;
              color: #17757a;
              cursor: pointer;
            }
          }
        }
      }
    }
    .pagination_box {
      margin-top: 20px;
    }

    .btn_list {
      display: flex;
      justify-content: center;
      font-size: 12px;
      margin-top: 20px;
      .add {
        border-radius: 4px;
        width: 64px;
        height: 33px;
        background-color: #17757a;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        color: #fff;
      }
      .cancel {
        border-radius: 4px;
        border: 1px solid #17757a;
        width: 64px;
        height: 33px;
        background-color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        color: #17757a;
        margin-left: 34px;
      }
    }
  }
}
</style>
